// extracted by mini-css-extract-plugin
export default {"faqs":"Faqs-module__faqs--my1ft","accordion-head":"Faqs-module__accordion-head--N4fPQ"};